import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React from 'react';

function ResetCell(props) {
  const { cell } = props;
  return cell.value ? cell.value.toString() : <DisabledTag>NA</DisabledTag>;
}

export default ResetCell;
